import React, { useState, useEffect  } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNeuroMessages } from "@ignitesales/neuro-application";

const WarningMessage = (warningState) => {
  const [warningIsActive, setWarningIsActive] = useState(false);
  const [contentIsActive, setContentIsActive] = useState(warningState);
  const messageContext = useNeuroMessages();
  const nowTime = new Date().getTime();
  const startTime = messageContext.getMessage('warning.startTime') ? messageContext.getMessage('warning.startTime') : '0';
  const expiryTime = messageContext.getMessage('warning.expiryTime') ? messageContext.getMessage('warning.expiryTime') : '0';

  useEffect(() => {
    (startTime < nowTime) && (nowTime < expiryTime) ? setWarningIsActive(true) : setWarningIsActive(false);
  }, [startTime, expiryTime]);

  const renderMessageContent = () => <section className='warning_content'>
    <p className='warning_message'><FormattedMessage id={'warning.content'}/></p>
  </section>;

  return (
    warningIsActive ? 
    <section className='warning_section'>
        { contentIsActive ? renderMessageContent() : null }
        <button className='warning_btn btn' onClick={ () => setContentIsActive(!contentIsActive) }>
            <FormattedMessage id={contentIsActive ? 'warning.closeMessage' : 'warning.openMessage'}/>
            <i className={contentIsActive ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} role="img" aria-label="Close" />
        </button>
    </section>
    : null
  );
}

export default WarningMessage;
